import { render, staticRenderFns } from "./platform_user_invoice.vue?vue&type=template&id=ec89553c"
import script from "./platform_user_invoice.vue?vue&type=script&lang=js"
export * from "./platform_user_invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports